/* This file is autogenerated, see readme.md for instructions */
import RenameSvgIcon from '@bloomreach/banana-theme/icons/rename.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const RenameIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <RenameSvgIcon />
    </Icon>
  );
});

RenameIcon.displayName = 'RenameIcon';

export default RenameIcon;
